import React from 'react';

import { green, orange, red } from 'data/colors';
import markIcon from 'images/icons/invite/mark.svg';
import renewalStatuses from 'data/renewal_method_statuses';
import statuses from 'data/policy_plan_statuses';
import Actions from './Actions';

const statusName = (value) => {
  const status = statuses.find((item) => item.value == value);
  return status == null ? '' : status.label;
};

const renewalStatusName = (value) => {
  const status = renewalStatuses.find((item) => item.value == value);
  return status == null ? '' : status.label;
};

const sessionsTitle = (sessions) => (sessions == '0' ? 'TA' : sessions);
const columns = (startEdit, startCreate, showChoosePlanModal) => [
  {
    name: 'Plan Name',
    selector: (row) => row.attributes.name,
    sortable: true,
  },
  {
    name: 'Sessions',
    selector: (row) => row.attributes.sessions,
    width: '90px',
    sortable: true,
    cell: (row) => sessionsTitle(row.attributes.sessions),
  },
  {
    name: 'Effective Date',
    selector: (row) => row.attributes.effective_date_formatted,
    sortable: true,
    width: '110px',
  },
  {
    name: 'Renewal Date',
    selector: (row) => row.attributes.renewal_date_formatted,
    sortable: true,
    width: '110px',
  },
  {
    name: 'Status',
    selector: (row) => row.attributes.status,
    sortable: true,
    width: '100px',
    cell: (row) => statusName(row.attributes.status),
  },
  {
    name: 'EEs',
    selector: (row) => row.attributes.employees_covered_title,
    width: '90px',
    sortable: true,
  },
  {
    name: 'Method',
    selector: (row) => row.attributes.renewal_method,
    width: '120px',
    sortable: true,
    cell: (row) => renewalStatusName(row.attributes.renewal_method),
    conditionalCellStyles: [
      {
        when: (row) => row.attributes.renewal_method === 'automatic',
        style: {
          color: green,
        },
      },
      {
        when: (row) => row.attributes.renewal_method === 'adjusted',
        style: {
          color: orange,
        },
      },
      {
        when: (row) => row.attributes.renewal_method === 'terminated',
        style: {
          color: red,
        },
      },
    ],
  },
  {
    name: 'Reminders',
    selector: (row) => row.attributes.renewal_notification,
    width: '80px',
    sortable: true,
    cell: (row) => (row.attributes.notification_active ? <img src={markIcon} /> : ''),
  },
  {
    name: 'Actions',
    sortable: false,
    width: '120px',
    right: true,
    cell: (row) => (
      <Actions
        row={row}
        startEdit={startEdit}
        startCreate={startCreate}
        showChoosePlanModal={showChoosePlanModal}
      />
    ),
  },
];

export default columns;
